import { Modal } from "bootstrap";

const selectorOfficeOpen = "[data-contacts-office-open]";
const selectorOfficeList = "[data-contacts-office]";
const idOfficeModal = "contacts-office__list";
const idOfficeTitle = "contacts-office__title";

const officeOpen = document.querySelectorAll(selectorOfficeOpen) || [];
const officeList = document.querySelectorAll(selectorOfficeList) || [];

officeOpen.forEach((btn) => {
	btn.addEventListener("click", function () {
		const open = this.dataset.contactsOfficeOpen;
		const title = this.innerHTML;
		const modalList = Modal.getInstance(document.getElementById(idOfficeModal));

		officeOpen.forEach((btnOfficeOpen) => {
			const hiddenItem = btnOfficeOpen.dataset.contactsOfficeOpen === open;

			btnOfficeOpen.classList.toggle("active", hiddenItem);
		});

		officeList.forEach((item) => {
			const hiddenItem = item.dataset.contactsOffice !== open;

			item.classList.toggle("d-none", hiddenItem);
		});

		document.getElementById(idOfficeTitle).innerHTML = title;
		modalList.hide();
	});
});
